import styled, { css } from 'styled-components';
import statusMapIcon_gas_blue from 'static/images/icon/statusMapIcon_gas_blue.png';

export const MapIconContainer = styled.div`
  width: 50px;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  cursor: pointer;

  ${props => 
    css`
      left: ${props.xcoordinate - 25}px;
      top: ${props.ycoordinate - 25}px;
    `
  }

  .areaBox {
    position: relative;

    .areaName {
      position: absolute;
      color: #fff;
      top: 40px;
      left: -75px;
      width: 200px;

      p {
        background: #4c4c4c;
        width: fit-content;
        margin: auto;
        padding: 0 10px;
        font-size: 12px;
      }
    }
  }

  img {
    width: 100%;
    height: 100%;
    content:url(${statusMapIcon_gas_blue});
  }
`;